import { chatEventEmitter } from '@wix/chat-sdk';
import { INIT_CHAT_SDK } from '../actions';
import { ViewerOnMessageReceivedEvent } from '../constants/viewer-event-types';
import wix from '../services/wix';
import { linguistHeader } from '../services/linguist-integration';
import { lazyLoaders } from '../services/loading-scheduler';

const chatSdkMiddleware = (store) => (next) => async (action) => {
  switch (action.type) {
    case INIT_CHAT_SDK: {
      const experiments = store.getState().experimentsRaw;
      const httpHeaders = { ...linguistHeader() };

      const lazySdk = await lazyLoaders.interactivity.chatSdk();
      lazySdk.chatSdk.init({
        chatServerUrl: '/',
        chatToken: action.coreChatToken,
        ...(action.isBusinessChat ? { preFetch: false } : {}),
        experiments,
        httpHeaders,
        tokenServer: { url: '/_api', authorization: wix.getInstance() },
      });

      chatEventEmitter.addListener(
        chatEventEmitter.CHAT_EVENTS.NEW_REALTIME_MESSAGE,
        (message) => wix.publishToPubSub(ViewerOnMessageReceivedEvent, message),
      );

      return next(action);
    }
    default:
      return next(action);
  }
};

export default chatSdkMiddleware;
